module.exports = __webpack_public_path__ + "img/banner-yeminli-sosyal-arabuluculuk.643c234b.png";